let result;

export const getMakeModelFilter = () => {
  if (result) return Promise.resolve(result);
  return import('./make-model-filter').then((module) => {
    result = module;
    return module;
  });
};